/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Color_TealInputs */



/**
* | output |
* | --- |
* | "Teal" |
*
* @param {Settings_Template_Color_TealInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_color_teal = /** @type {((inputs?: Settings_Template_Color_TealInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Color_TealInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Petrolblauw")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bleu pétrole")
	return /** @type {LocalizedString} */ ("Teal")
});